import { ReactNode } from 'react'
import { Switch } from '../components'
import { useUiKit } from '../providers'

export function ThemeSwitcher(): ReactNode {
  const { isThemeDark, setIsThemeDark } = useUiKit()

  return <Switch className="cursor-pointer" checked={isThemeDark} onClick={() => setIsThemeDark(!isThemeDark)} />
}
